<template>
    <div
        v-show="opened"
        class="header-mobile-navigation__container"
        @click.stop="$emit('close')"
    >
        <transition name="ui-fade">
            <nav
                v-show="opened"
                class="header-mobile-navigation"
                @click.stop
            >
                <template v-for="(item, index) in navItems" :key="index">
                    <div
                        v-if="item.subItems && item.subItems.length"
                        class="header-mobile-navigation__parent"
                        :class="{ 'header-mobile-navigation__parent--opened': item.active }"
                    >
                        <div
                            class="header-mobile-navigation__parent-title"
                            @click="item.active = !item.active"
                        >
                            <div class="header-mobile-navigation__parent-label">{{ item.label }}</div>
                            <div class="header-mobile-navigation__parent-icon"></div>
                        </div>
                        <transition name="ui-fade">
                            <div v-show="item.active" class="header-mobile-navigation__sub-items">
                                <router-link
                                    v-for="(subItem, subIndex) in item.subItems"
                                    :key="subIndex"
                                    :to="subItem.link"
                                    class="header-mobile-navigation__sub-link"
                                >
                                    {{ subItem.label }}
                                </router-link>
                            </div>
                        </transition>
                    </div>

                    <router-link
                        v-else
                        :to="item.link"
                        class="header-mobile-navigation__link"
                        :class="{ 'header-mobile-navigation__link_active': isActive(item) }"
                    >
                        {{ item.label }}
                    </router-link>
                </template>
            </nav>
        </transition>
    </div>
</template>

<script setup lang="ts">
    import { ref } from 'vue';
    import { useRoute } from 'vue-router';

    import { injectStrict } from '@/injection/injectStrict.ts';
    import { AuthKey } from '@/injection/keys.ts';

    import { getAdminNavItems, getDealerNavItems, NavItem, NavItems } from '@/types/navigation.type.ts';
    import { CurrentUser } from '@/types/user.type.ts';

    defineProps({
        opened: {
            type: Boolean,
            default: false,
        },
    });

    defineEmits<{
        (e: 'close'): void,
    }>();

    const $Auth = injectStrict(AuthKey);

    const route = useRoute();

    const currentUser: CurrentUser = $Auth.getCurrentUser();

    const navItems = ref<NavItems>(currentUser.is_admin ? getAdminNavItems() : getDealerNavItems());

    const isActive = (navItem: NavItem): boolean => {
        const routes = route.matched.map((m) => m.path);

        return routes.includes(navItem.link);
    };
</script>

<style scoped lang="scss">
    @use 'HeaderMobileNavigation';
</style>
